// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-block[data-v-0388442c] {
  position: absolute;
  width: 60%;
  margin-left: 20%;
  left: 0;
  margin-top: 8px;
}
.pagination-block .pagination-text[data-v-0388442c] {
  display: inline-block;
  width: 100%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-questionnaire.vue","webpack://./np-questionnaire.vue"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,OAAA;EACA,eAAA;ACAR;ADEI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;ACAR","sourcesContent":["\n    .pagination-block {\n        position: absolute;\n        width: 60%;\n        margin-left: 20%;\n        left: 0;\n        margin-top: 8px;\n    }\n    .pagination-block .pagination-text {\n        display: inline-block;\n        width: 100%;\n        text-align: center;\n    }\n",".pagination-block {\n  position: absolute;\n  width: 60%;\n  margin-left: 20%;\n  left: 0;\n  margin-top: 8px;\n}\n.pagination-block .pagination-text {\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
